var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6612 3.33228H3.33215C2.41197 3.33228 1.66602 4.07823 1.66602 4.99841V14.9952C1.66602 15.9154 2.41197 16.6613 3.33215 16.6613H16.6612C17.5814 16.6613 18.3273 15.9154 18.3273 14.9952V4.99841C18.3273 4.07823 17.5814 3.33228 16.6612 3.33228Z",
    stroke: "#F0E1CE",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3273 5.83154L10.8547 10.58C10.5975 10.7412 10.3002 10.8266 9.99668 10.8266C9.69318 10.8266 9.39581 10.7412 9.13862 10.58L1.66602 5.83154",
    stroke: "#F0E1CE",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsg);
export default __webpack_public_path__ + "static/media/msg.9d0f4c132c27914990ddfe414437d85a.svg";
export { ForwardRef as ReactComponent };